import { render, staticRenderFns } from "./StepDeliveryPage.vue?vue&type=template&id=4df2736a&scoped=true"
import script from "./StepDeliveryPage.vue?vue&type=script&lang=js"
export * from "./StepDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df2736a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df2736a')) {
      api.createRecord('4df2736a', component.options)
    } else {
      api.reload('4df2736a', component.options)
    }
    module.hot.accept("./StepDeliveryPage.vue?vue&type=template&id=4df2736a&scoped=true", function () {
      api.rerender('4df2736a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reservations/advance/steps/StepDeliveryPage.vue"
export default component.exports